import { useEffect, useState } from "react";
import { GlassContainer } from "../components/Containers";
import { Button, Input, Modal, notification, Typography } from "antd";
import chatrivonobg from "../files/chatrivo_nobg.png";
import {
  DownloadOutlined,
  TeamOutlined,
  ExportOutlined,
  UserOutlined,
  EyeTwoTone,
  EyeInvisibleOutlined,
  LockOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import Buttons from "../components/Buttons";
import { Turnstile } from "@marsidev/react-turnstile";

const { Title, Text } = Typography;

export default function Projects(args) {
  const [modalOpen, setModalOpen] = useState(false);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const [token, setToken] = useState(null);
  const [api, contextHolder] = notification.useNotification();
  const openNotification = (type, errorMsg, placement = args.device === "pc" ? "bottomRight" : "topRight") => {
    api[type === "no_bot" || type === "fields_missing" ? "error" : type]({
      title:
        type === "info"
          ? "Kimlik doğrulanıyor..."
          : type === "success"
            ? "Kimlik doğrulandı!"
            : type === "error"
              ? "Kimlik doğrulanamadı!"
              : `Bildirim`,
      description:
        type === "info" ? null : type === "success" ? (
          "Dosya indirilmesi başlatılıyor..."
        ) : type === "no_bot" ? (
          "Captcha doğrulaması yapılmadı!"
        ) : type === "fields_missing" ? (
          "Lütfen tüm boşlukları doldurun."
        ) : (
          <p>{errorMsg}</p>
        ),
      icon: type === "info" && <LoadingOutlined style={{ color: "#108ee9" }} />,
      placement,
    });
  };

  useEffect(() => {
    args.setCurrent("projects");
    document.title = "Projeler | Zenofy";
  }, [args]);
  console.log(args.setCurrent);
  return (
    <div style={{ marginTop: "4rem", display: "flex", flexDirection: "column", alignItems: "center" }}>
      <GlassContainer
        width="95vw"
        height="60rem"
        bigger_height="50rem"
        device={args.device}
        inside={
          <div
            style={{
              width: "100%",
              height: "100%",

              display: "flex",
              flexDirection: args.device === "phone" ? "column" : "row",
              alignItems: "center",
              justifyContent: "center",
              padding: args.device === "phone" ? "calc(1rem + 3vw) 0" : "0 calc(1rem + 3vw)",

              gap: "calc(4rem + 4vw)",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                width: args.device === "phone" ? "100%" : "30%",
                height: args.device === "phone" ? "30%" : "100%",
              }}
            >
              <img src={chatrivonobg} alt="chatrivo-logo" style={{ width: "70%" }} />
            </div>
            <div
              style={{
                width: args.device === "phone" ? "100%" : "50%",
                height: args.device === "phone" ? "50%" : "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                textAlign: "center",
              }}
            >
              <Title
                style={{
                  marginBottom: "1rem",
                  color: "var(--light)",
                  fontSize: args.device === "pc" ? "calc(10px + 4vw)" : "calc(1rem + 9vw)",
                }}
              >
                Arkadaşlarınla Gönlün Rahat Takıl!
              </Title>
              <Text
                style={{
                  marginBottom: "6rem",
                  color: "var(--light)",
                  fontSize: args.device === "pc" ? "calc(2rem + 1vw)" : "calc(1rem + 1vw)",
                }}
              >
                Chatrivo ile arkadaşlarınla buluş, sohbet et ve eğlen.
              </Text>
              <Buttons
                buttonsPrimary={["Hemen Dene!"]}
                buttons={["Forum", "Daha Fazla"]}
                onClickPrimary={() => setModalOpen(true)}
                href={["/forum/chatrivo", "/projects/ChatRivo"]}
                tooltipPrimary={[<Text italic>Kapalı Alpha Sürümünü İndir!</Text>]}
                iconsPrimary={[<DownloadOutlined />]}
                icons={[<TeamOutlined />, <ExportOutlined />]}
                iconPlacement="end"
                device={args.device}
              ></Buttons>
              <Modal
                footer={null}
                open={modalOpen}
                styles={{
                  container: {
                    borderRadius: 14,
                    border: "1px solid #ccc",
                    padding: 0,
                    overflow: "hidden",
                  },
                  header: {
                    padding: 16,
                  },
                  body: {
                    padding: 16,
                  },
                  footer: {
                    padding: "16px 10px",
                    backgroundColor: "#fafafa",
                  },
                }}
                centered={true}
                mask={{ enabled: true, blur: true }}
                onOk={() => setModalOpen(false)}
                onCancel={() => setModalOpen(false)}
                title="Alpha v1.1.3 [20 Mayıs 2026]"
                style={{ alignItems: "center" }}
                bodyStyle={{ display: "flex", flexDirection: "column", alignItems: "center" }}
              >
                {contextHolder}
                <Typography.Title level={3} style={{ textAlign: "center", marginTop: "0", marginBottom: "30px" }}>
                  Kapalı Alpha Sürümünü İndirebilmek için Kimliğini Doğrula
                </Typography.Title>
                <Input
                  size="large"
                  style={{ color: "#1d7595", marginBottom: "5px" }}
                  placeholder="Kullanıcı adı"
                  onChange={(e) => setUsername(e.target.value)}
                  prefix={<UserOutlined />}
                />
                <Input.Password
                  size="large"
                  style={{ color: "#1d7595", marginBottom: "5px" }}
                  onChange={(e) => setPassword(e.target.value)}
                  iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
                  placeholder="Şifre"
                  prefix={<LockOutlined />}
                />

                <Turnstile siteKey={process.env.REACT_APP_VITE_TURNSTILE_SITE_KEY} onSuccess={setToken} />
                <Button
                  type="primary"
                  onClick={async () => {
                    try {
                      openNotification("info");
                      const response = await fetch("https://api.zenofy.tr/download/AlphaV1.1.3-windows", {
                        method: "POST",
                        headers: {
                          "Content-Type": "application/json",
                        },
                        body: JSON.stringify({ username: username, password: password, turnstileToken: token }), // Data must be stringified
                      });

                      if (response.ok) {
                        openNotification("success");
                        const blob = await response.blob();
                        const url = window.URL.createObjectURL(blob);
                        const link = document.createElement("a");
                        link.href = url;
                        link.setAttribute("download", "chatrivo_alpha_setup_v1.1.3.exe");
                        document.body.appendChild(link);
                        link.click();
                        link.remove();
                        window.URL.revokeObjectURL(url);
                      } else {
                        openNotification("error", await response.text());
                      }
                    } catch (error) {
                      console.log(error);
                    }
                  }}
                >
                  {" "}
                  İndir <DownloadOutlined />
                </Button>
              </Modal>
            </div>
          </div>
        }
      ></GlassContainer>

      <GlassContainer
        width="95vw"
        height="60rem"
        bigger_height="50rem"
        device={args.device}
        inside={
          <div
            style={{
              width: "100%",
              height: "100%",

              display: "flex",
              flexDirection: args.device === "phone" ? "column" : "row",
              alignItems: "center",
              justifyContent: "center",
              padding: args.device === "phone" ? "calc(1rem + 3vw) 0" : "0 calc(1rem + 3vw)",

              gap: "calc(4rem + 4vw)",
            }}
          >
            <div
              style={{
                width: args.device === "phone" ? "100%" : "50%",
                height: args.device === "phone" ? "50%" : "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                textAlign: "center",
              }}
            >
              <Title
                style={{
                  marginBottom: "1rem",
                  color: "var(--light)",
                  fontSize: args.device === "pc" ? "calc(10px + 4vw)" : "calc(1rem + 9vw)",
                }}
              >
                Hayatını istediğin gibi düzenle, planla ve hatırla.
              </Title>
              <Text
                style={{
                  marginBottom: "6rem",
                  color: "var(--light)",
                  fontSize: args.device === "pc" ? "calc(1rem + 1vw)" : "calc(1rem + 1vw)",
                }}
              >
                Mis To Do ile haftalık programını oluştur ve beklenmeyen şeylere karşı hazırlıklı ol!
              </Text>
              <Buttons
                buttonsPrimary={["İndir"]}
                buttons={["Forum", "Daha Fazla"]}
                href={["/forum/mistodo", "/projects/MisToDo"]}
                hrefPrimary={["https://api.zenofy.tr/mis_to_do/MisToDo-Alpha-v0.6.2.apk"]}
                tooltipPrimary={[<Text>Hemen İndir!</Text>]}
                iconsPrimary={[<DownloadOutlined />]}
                icons={[<TeamOutlined />, <ExportOutlined />]}
                iconPlacement="end"
                device={args.device}
              ></Buttons>
            </div>

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                width: args.device === "phone" ? "100%" : "30%",
                height: args.device === "phone" ? "30%" : "100%",
              }}
            >
              <Typography.Title style={{ color: "white", fontSize: "7rem", margin: "0", textAlign: "center" }}>Mis To Do</Typography.Title>
              <Typography.Title style={{ color: "white", fontSize: "2rem", marginTop: "0" }}>[Alpha]</Typography.Title>
            </div>
          </div>
        }
      ></GlassContainer>
    </div>
  );
}

/*<GlassContainer
              width={args.device === "phone" ? "90vw" : "60vw"}
              height="40rem"
              bigger_height="50rem"
              device={args.device}
              inside={
                <div
                  style={{
                    padding: "1rem",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <Carousel
                    style={{
                      width: "80vw",
                      height: args.device === "phone" ? "40rem" : "50rem",
                      display: "flex",
                      alignItems: "center",
                      textAlign: "center",
                    }}
                    autoplay={{ dotDuration: true }}
                    autoplaySpeed={5000}
                    draggable
                  >
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <Title style={title(args.device)}>
                        <div
                          style={{
                            width: "100%",
                            height: args.device === "phone" ? "40rem" : "50rem",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                          }}
                        >
                          1
                        </div>
                      </Title>
                    </div>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <Title style={title(args.device)}>
                        <div
                          style={{
                            width: "100%",
                            height: args.device === "phone" ? "40rem" : "50rem",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                          }}
                        >
                          2
                        </div>
                      </Title>
                    </div>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <Title style={title(args.device)}>
                        <div
                          style={{
                            width: "100%",
                            height: args.device === "phone" ? "40rem" : "50rem",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                          }}
                        >
                          3
                        </div>
                      </Title>
                    </div>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <Title style={title(args.device)}>
                        <div
                          style={{
                            width: "100%",
                            height: args.device === "phone" ? "40rem" : "50rem",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                          }}
                        >
                          4
                        </div>
                      </Title>
                    </div>
                  </Carousel>
                </div>
              }
            ></GlassContainer> */
